<template>
  <div class="board" ref="board">
    <main-menu></main-menu>

    <div class="main">
      <template v-if="showSubMenu">
        <sub-menu class="main-left"></sub-menu>
      </template>

      <div
        class="content main-right"
        :class="{ activeContent: isCollapse }"
        id="content"
        ref="content"
      >
        <transition name="fade">
          <router-view ref="view" class="tablelist loading-area"></router-view>
        </transition>
      </div>
    </div>

    <!-- <Footercus class="footer"></Footercus> -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import MainMenu from "../page/commons/menu/mainMenu/mainMenu";
import SubMenu from "../page/commons/menu/subMenu/subMenu";
import Bread from "./commons/bread.vue";
import Footercus from "./commons/footer.vue";
import $ from "jquery";
import websocket from "../helper/websocket";
import { Notification } from "element-ui";
export default {
  name: "maincus",
  data: function() {
    return {
      showSubMenu: false,
      fade: "fade",
    };
  },
  components: {
    // Headercus,
    // Sidecus,
    Bread,
    Footercus,
    MainMenu,
    SubMenu,
  },
  created() {
    document.getElementById("appLoading").style.display = "none";
    websocket.websocketListener((msg) => {
      const pathHash = window.location.hash;
      if (pathHash === "#/main/home") {
        this.setArrearsList({...msg});
      } else {
        Notification({
          type: "info",
          title: msg.plate,
          message: msg.message,
          position: "bottom-right",
          duration: 0,
        });
      }
    });
  },
  mounted() {
    setInterval(() => {
      
    }, 1000);
    this.getAdminData();
    const r = this.$route.path;
    this.$nextTick(function() {
      if (r === "/main/home") {
        this.showSubMenu = false;
        this.$refs.content.classList.remove("main-right");
      } else {
        this.showSubMenu = true;
        this.$refs.content.classList.add("main-right");
      }
    });
  },
  computed: {
    ...mapState({
      isCollapse: (state) => state.menu.isCollapse,
      mainMenuHref: (state) => state.menu.mainMenuHref,
    }),
  },
  watch: {
    $route(newVal, oldVal) {
      this.$nextTick(function() {
        if (newVal.path === "/main/home") {
          this.showSubMenu = false;
          this.$refs.content.classList.remove("main-right");
        } else {
          this.showSubMenu = true;
          this.$refs.content.classList.add("main-right");
        }
      });
    },
  },
  methods: {
    ...mapActions(["getAdminData"]),
    ...mapActions("arrearsInformation", ["setArrearsList"]),
  },
};
</script>
<style scoped>

.board {
  min-width: 1440px;
  margin: 0 auto;
  height: 100%;
}

.headercus {
  width: 100%;
  /* height: 50px; */
  /* box-shadow: 0px 10px 20px #777; */
}
.footer {
  width: 100%;
  /* background:#f9f9fb;  */
  background: #ebeef5;
}
.main {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  /* margin-top:10px; */
  position: relative;
  height: calc(100% - 75px);
}
.main .main-right {
  width: calc(100% - 258px);
  /* background:#eff2f7; */
  z-index: 10000;
  overflow: hidden;
  position: relative;
  /* border-radius: 5px; */
  /* overflow:auto; */
}
.main .content {
  width: 100%;
  padding-top: 0;
}

.main .activeContent {
  left: 64px;
  transition: all 0.3s ease;
}

.main-left {
  /* width: 15%; */
  width: 258px;
  /* background: #191c23; */
  overflow: hidden;
  overflow-y: auto;
}
.main-left::-webkit-scrollbar {
  display: none;
}
.tablelist {
  height: 100%;
  background: white;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
